import { ethers } from "ethers";
import { useMemo } from "react";
import { erc20ABI, useChainId } from "wagmi";
import { buyContractABI } from "../abis/buyContractABI";
import { useWeb3Ts } from "../context/Web3TsContext";
import { useEthersSigner } from "./useEthers";
export const useContract = () => {
 const signer = useEthersSigner();
 const chainId = useChainId();
 const web3TsConfig = useWeb3Ts();
 const contractUsdt = useMemo(() => {
  if (signer === undefined) return undefined;
  const contractUsdt = new ethers.Contract(
   chainId === 56
    ? "0x55d398326f99059fF775485246999027B3197955"
    : "0x337610d27c682E347C9cD60BD4b3b107C9d34dDd",
   erc20ABI,
   signer
  );
  return contractUsdt;
 }, [signer, chainId]);
 const contract = useMemo(() => {
  if (signer === undefined) return undefined;
  const contract = new ethers.Contract(
   web3TsConfig.config.mainContract.contractAddress,
   erc20ABI,
   signer
  );
  return contract;
 }, [signer, web3TsConfig.config.mainContract.contractAddress]);
 const contractBuy = useMemo(() => {
  if (signer === undefined) return undefined;
  const contract = new ethers.Contract(
   web3TsConfig.config.buyContract.contractAddress,
   buyContractABI(web3TsConfig.config),
   signer
  );
  return contract;
 }, [
  signer,
  web3TsConfig.config.buyContract.contractAddress,
  web3TsConfig.config.buyContract.buyUSDTMethod,
  web3TsConfig.config.buyContract.buyMethod,
 ]);
 return { contractUsdt, contract, contractBuy };
};
